import React from 'react';
import { Pressable, StyleSheet } from 'react-native';

import ChevronRight from '@/assets/icons/chevronRightCasino';
import { Text } from '@/components/TextComponent';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { appTheme } from '@/components/lib/theme';
import { useHover } from '@/feature/responsive-design/hooks/use-hover';

const CIRCLE_SIZE = 36;

type ViewAllCardProps = {
    width: number;
    height: number;
    label: string;
    onPress: () => void;
    testID?: string;
};

export const ViewAllCard = ({ width, height, label, onPress, testID }: ViewAllCardProps) => {
    const { hovered, hoverHandlers } = useHover();

    return (
        <Pressable
            {...hoverHandlers}
            onPress={onPress}
            style={[styles.card, { width, height }]}
            accessibilityRole="button"
            accessibilityLabel={label}
            testID={testID}
        >
            <Box
                alignItems="center"
                justifyContent="center"
                backgroundColor={ds.colorToken.background.neutral.subtle}
                borderRadius="r96"
                height={CIRCLE_SIZE}
                width={CIRCLE_SIZE}
            >
                <ChevronRight color={ds.colorValue.icon.primary} width={20} height={20} />
            </Box>
            <Text color={ds.colorToken.text.primary} variant="titleMedium" marginTop="s12">
                {label}
            </Text>
            {hovered ? <Box pointerEvents="none" style={[StyleSheet.absoluteFill, styles.hoverWash]} /> : null}
        </Pressable>
    );
};

const styles = StyleSheet.create({
    card: {
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: ds.colorValue.background.neutral.subtler,
        borderColor: ds.colorValue.border.strong,
        borderRadius: appTheme.borderRadii.r20,
        borderCurve: 'continuous',
        borderWidth: 1,
    },
    hoverWash: {
        backgroundColor: ds.colorValue.border.strong,
        borderRadius: appTheme.borderRadii.r20,
    },
});
